import React from "react";
import { useMediaQuery } from "react-responsive";

export default function P({ style, children }) {
  const mediaQuery = {
    isDesktopOrLaptop: useMediaQuery({ query: "(min-width: 1224px)" }),
    isBigScreen: useMediaQuery({ query: "(min-width: 1824px)" }),
    isTabletOrMobile: useMediaQuery({ query: "(max-width: 1224px)" }),
    isPortrait: useMediaQuery({ query: "(orientation: portrait)" }),
    isRetina: useMediaQuery({ query: "(min-resolution: 2dppx)" })
  };
  return (
    <p
      style={{
        fontStyle: "normal",
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "20px",
        textAlign: "center",
        letterSpacing: "0.25px",
        color: "#011F31",
        margin: `0 ${mediaQuery.isTabletOrMobile ? "1rem" : "3rem"}`,
        ...style
      }}
    >
      {children}
    </p>
  );
}
